(function () {
  document.addEventListener('shopify:section:load', (e) => {
    // Get the loaded section
    const section = JSON.parse(
      e.target.getAttribute('data-shopify-editor-section')
    );

    const swiperElement = e.target.querySelector('.swiper-slideshow');
    if (swiperElement) {
      let autoplayVal = JSON.parse(
        swiperElement.getAttribute('data-autoplay').toLowerCase()
      );
      let interval = JSON.parse(swiperElement.getAttribute('data-interval'));
      // Swiper autoplay settings
      let autoplaySettings;
      if (autoplayVal === true) {
        autoplaySettings = {
          delay: interval * 1000,
        };
      } else {
        autoplaySettings = false;
      }
      // Check if loaded section is slideshow
      if (section.type === 'slideshow') {
        const swiper = new Swiper(swiperElement, {
          direction: 'horizontal',
          loop: true,
          autoplay: autoplaySettings,
          // Disable preloading of all images
          preloadImages: false,
          // Enable lazy loading
          lazy: true,
          // autoplay: settings.autoplay,
          // If we need pagination
          pagination: {
            clickable: true,
            el: '.swiper-pagination',
          },
          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }
    }
  });
})();
